import React, { useState } from "react";

import { useTranslation } from 'react-i18next';

// react component for creating dynamic tables
import ReactTable from "react-table";

// nodejs library to set properties for components
import PropTypes from "prop-types";

// @mui/icons-material
import Add from "@mui/icons-material/Add";
import Refresh from "@mui/icons-material/Refresh";
import Check from "@mui/icons-material/Check";

// core components
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";

import Table from "../components/Table.jsx";
import Button from "../components/Button.jsx";
import OthelloMensaje from './OthelloMensaje.jsx';
import { GetGridButtons } from "../othelloFunciones.jsx";
import { TipoOthelloFieldGrid, DataStateModal, ModoModal, DialogOthelloResult, MessageOthelloBoxButtons} from "../othelloConstantes.jsx";
import { MensajeModalSegunEstado2 } from "../othelloFunciones.jsx";
import DataTable from "../components/Tables/DataTable/index.js";

import OthelloCheckBox from './OthelloCheckBox.jsx';
import { Grid } from "@mui/material";

var moment = require('moment');
require('moment/locale/es');

export default function OthelloGrid({ ...props }) {

    const { gridmode, datasource, datacabeceros, datashow, datasourcefields, onEdit, onDelete, onNuevo, onRefresh, textNuevo, questionDelete, permitefiltrar, verpaginaciontop, verpaginacionbottom, tamanopagina, arrayBotonesExtras, onBotonExtraClick, onSelectAllCheckbox, datosAdicionales, showTotalYPaginacion } = props

    const { t } = useTranslation();

    const [stateModal, setstateModal] = useState(DataStateModal.dsClosed);
    const [modeModal, setmodeModal] = useState(ModoModal.SinDefinir);

    const [itemdelete, setitemdelete] = useState(null);
    const [indexdelete, setindexdelete] = useState(null);
    const [optionstable, setoptionstable] = useState({ indexPage: 0, rowsPage: props.tamanopagina != null ? props.tamanopagina : 10, orderDesc: false, columnaOrder: "", valuesfiltro: [] });
    const [checkedstate, setcheckedstate] = useState(false);
   
    const handleDelete = (valor, index) =>
    {
        if (valor != null)
        {
            setstateModal(DataStateModal.dsOpen);
            setmodeModal(ModoModal.Delete);
            setitemdelete(valor);
            setindexdelete(index);            
        }
    }

    const othelloModalResul = (modo, result, valor) => {

        //Si hemos recibido un true es que debemos realizar alguna operacion con los recibido
        if (result == DialogOthelloResult.OK) {
            //if (modo == ModoModal.Delete)        
            //Ahora solo esta la opcion de delete, por tanto
            props.onDelete(itemdelete, indexdelete);

            setstateModal(DataStateModal.dsClosed);
            setmodeModal(ModoModal.SinDefinir);
            setitemdelete(null);
            setindexdelete(null);
        }
        //sino simplemente cerramos el modal
        else {
            setstateModal(DataStateModal.dsClosed);
            setmodeModal(ModoModal.SinDefinir);
            setitemdelete(null);
            setindexdelete(null);
        }            
    }

    const handleCheckOnChange = (event, row, campo, eventclick) => {

        //Si cambio el estado anterior
        if (event.target != checkedstate) {
            //// this.setState({ [event.target.name]: event.target.value });
            //this.setState({ checkedstate: event.target.checked, evento: true });

            if (eventclick != null)
                eventclick(event.target.checked, row, campo);

            // event.checked = event.target.checked;
        }
    };

    //Metodo que devuelve los datos segun el modo que hemos indicado del grid
    const getDataTable = (datasource, datashow, datasourcefields, gridmode, onEdit, onDelete) =>
    {
        //Si estamos en modo simple
        if (gridmode != null && (gridmode == "simple" || gridmode == "simplecolor")) {
            let valores = datasource != null ? datasource.map((item, index) => {
                //Creamos una copia de los valores a mostrar
                let valor_Aux = Object.create(datashow);

                //por cada campo vamos obteniendo el valor y cambiandolo por el valor real
                datashow.map((field, col) =>
                {
                    //Si el campo tiene valor, es que es un campo real
                    if (field != "botones") {
                        //Ahora compruebo que no tiene una conversion
                        if (datasourcefields != null) {
                            //Buscamos el primer datasource que esta asociado al campo con el que estamos trabajando
                            let datafield = datasourcefields.find(x => x.fieldname == field);

                            //Si existe datasource para el campo actual
                            if (datafield != null) {
                                if (datafield.tipofield == TipoOthelloFieldGrid.OthelloComboBox && datafield.items != null) {
                                    //Buscamos obtener el item asociado al valor del campo del item actual
                                    let selected = datafield.items.find(x => x.valor == item[field]);

                                    //Si de la lista de item a un valor con dicho campo entonces el valor a mostrar sera el nombre asociado
                                    if (selected != null)
                                        return valor_Aux[col] = selected.name;
                                }
                                else if (datafield.tipofield == TipoOthelloFieldGrid.OthelloDate || datafield.tipofield == TipoOthelloFieldGrid.OthelloDateTime) {

                                    if (item[field] != null && item[field] != "") {
                                        let res = item[field];
                                        let timefinal = new Date(res);

                                        if (timefinal != "Invalid Date")
                                        {
                                            if (datafield.tipofield == TipoOthelloFieldGrid.OthelloDate)
                                                res = moment(timefinal).format("DD/MM/YYYY");
                                            else
                                                res = moment(timefinal).format("DD/MM/YYYY HH:mm:ss");
                                        }

                                        return valor_Aux[col] = res;
                                    }
                                    else
                                        return valor_Aux[col] = "";
                                }
                                else if (datafield.tipofield == TipoOthelloFieldGrid.OthelloImagen)
                                    return valor_Aux[col] = <img style={{ height: "42px", width: "42px" }} src={item[field]} alt="..." />
                                else if (datafield.tipofield == TipoOthelloFieldGrid.OthelloCurrency)
                                    return valor_Aux[col] = <div style={{ textAlign: "right", marginRight: 10 }}>{item[field] != null ? item[field].toFixed(2) : "0.00-"}</div>
                                else if (datafield.tipofield == TipoOthelloFieldGrid.OthelloCurrencyNullable)
                                    return valor_Aux[col] = <div style={{ textAlign: "right", marginRight: 10 }}>{item[field] != null ? item[field].toFixed(2) : ""}</div>
                                else if (datafield.tipofield == TipoOthelloFieldGrid.OthelloCurrency4Dec)
                                    return valor_Aux[col] = <div style={{ textAlign: "right", marginRight: 10 }}>{item[field] != null ? item[field].toFixed(4) : "0.0000-"}</div>
                                //else if (datafield.tipofield == TipoOthelloFieldGrid.OthelloCheckBox)
                                //   return valor_Aux[col] = <div style={{ textAlign: "right", marginRight: 10 }}>{item[field] != null ? item[field].toFixed(4) : "0.0000-"}</div>      
                            }
                        }

                        //Si llego hasta qui es que no tiene datasource asociado o valor dentro de este por tanto, le asociado el valor que tenia
                        return valor_Aux[col] = item[field];
                    }
                    //sino, es el campo que ponemos por defecto para los botones
                    else
                        return valor_Aux[col] = GetGridButtons(item, index, onEdit, onDelete != null ? handleDelete : null);
                });

                //Si estamos en modo simple directamento proporciono el valor
                if (gridmode == "simple")
                    return valor_Aux;
                //Sino, trato con el color
                else {
                    let colorfinal = index % 2 == 0 ? "info" : "";

                    let recipient =
                    {
                        color: colorfinal,
                        data: valor_Aux,
                    };

                    return recipient;
                }
            }) : [];

            return valores;
        }
        //Sino, es que estamos en modo normal, que es el de ReactTable
        else {
            let valores = datasource != null && datasource.length > 0 ? datasource.map((item, index) => {
                let recipient = "";

                //Si tenemos botones de edicion o eliminacion entonces debo añadir al item un campo de botones
                if (onEdit != null || onDelete != null) {
                    recipient =
                    {
                        ...item,
                        botones: GetGridButtons(item, index, onEdit, onDelete != null ? handleDelete : null)
                    };
                }
                else {
                    recipient = item;
                }

                //Ahora compruebo que no tiene una conversion
                if (datasourcefields != null) {
                    //Buscamos el primer datasource que esta asociado al campo con el que estamos trabajando
                    datasourcefields.map(x => {
                        if (x.tipofield == TipoOthelloFieldGrid.OthelloImagen)
                            recipient[x.fieldname] = <img style={{ height: "42px", width: "42px" }} src={recipient[x.fieldname]} alt="..."  />
                        else if (x.tipofield == TipoOthelloFieldGrid.OthelloButton) {
                            let colorfinal = { color: x.color, disabled: false };

                            if (props.onSetPropertiesButtonRow != null)
                                props.onSetPropertiesButtonRow(item, x.fieldname, colorfinal);

                            return recipient[x.fieldname] = <Button iconOnly circular={true} onClick={() => x.onclick != null ? x.onclick(item, x.fieldname, index) : {}} color={colorfinal != null && colorfinal.color != null ? colorfinal.color : 'light'} disabled={colorfinal.disabled}>
                                <x.icon />
                            </Button>
                        }
                        else if (x.tipofield == TipoOthelloFieldGrid.OthelloCheckBox) {
                            try {
                                let key = index + "_" + x.fieldname;


                                //Si no estamos con un componente valido es que estamos con el valor del checkBox, si no, es que estamos con el propio checkBox
                                if (!React.isValidElement(recipient[x.fieldname])) {
                                    recipient[x.fieldname] = <Checkbox
                                        id={key}
                                        name={key}
                                        tabIndex={-1}
                                        checked={recipient[x.fieldname] == true || recipient[x.fieldname] == false ? recipient[x.fieldname] : false}
                                        disabled={x.checkdisabled != null ? x.checkdisabled : false}
                                        onChange={(e) => handleCheckOnChange(e, index, x.fieldname, x.onclick)}
                                        checkedIcon={<Check /*className={classes.checkedIcon}*/ />}
                                        icon={<Check/* className={classes.uncheckedIcon}*/ />}
                                        //classes={{
                                        //    checked: classes.checked,
                                        //    root: classes.checkRoot
                                        //}}
                                    />
                                }
                            }
                            catch { }
                        }
                    });
                }

                return recipient;

            }) : [];

            return valores;
        }
    }

    const getColumnas = (datashow, datacabeceros, gridmode, datasourcefields) =>
    {
        //Si estamos en modo simple las columnas son directamente las que me indique los cabeceros
        if (gridmode != null && (gridmode == "simple" || gridmode == "simplecolor"))
            return datacabeceros != null && datacabeceros != "" && Array.isArray(datacabeceros) ? datacabeceros : [];
        //sino, en modo normal monto las columnas con las propiedades necesarias
        else {
            let columnas = [];

            if (datashow != null && Array.isArray(datashow)) {
                datashow.map((item, index) => {

                    //Si el campo no indica botones entonces
                    if (item != "botones") {
                        let cabecera = datacabeceros[index];

                        let nuevoitem = { Header: cabecera, accessor: item };

                        //Ahora compruebo que no tiene una conversion
                        if (datasourcefields != null) {
                            //Busco si hay algun combo asociado al item a tratar
                            let itemdatasource = datasourcefields.find(x => (x.tipofield == TipoOthelloFieldGrid.OthelloComboBox || x.tipofield == TipoOthelloFieldGrid.OthelloButton || x.tipofield == TipoOthelloFieldGrid.OthelloCheckBox
                                || x.tipofield == TipoOthelloFieldGrid.OthelloDateTime || x.tipofield == TipoOthelloFieldGrid.OthelloDate || x.tipofield == TipoOthelloFieldGrid.OthelloCurrency
                                || x.tipofield == TipoOthelloFieldGrid.OthelloCurrency4Dec || x.tipofield == TipoOthelloFieldGrid.OthelloEditLargo) && x.fieldname == item);

                            //Si se ha encontrado un item
                            if (itemdatasource != null) {
                                //Si el item es de tipo ComboBox
                                if (itemdatasource.tipofield == TipoOthelloFieldGrid.OthelloComboBox) {
                                    let res = "";

                                    nuevoitem.id = itemdatasource.fieldname;
                                    nuevoitem.sortable = true;
                                    nuevoitem.sortMethod = (a, b) => {

                                        let aaa = a.props.children + "";
                                        let bbb = b.props.children + "";

                                        if (aaa > bbb)
                                            return 1;
                                        if (bbb > aaa)
                                            return -1;

                                        return 0;
                                    }

                                    //Si hay items
                                    if (itemdatasource != null && itemdatasource.tipofield == TipoOthelloFieldGrid.OthelloComboBox && itemdatasource.items != null && itemdatasource.items.length > 0) {
                                        res = itemdatasource.items.map((prop, key) => {
                                            return (<MenuItem value={prop.name}>{prop.name}</MenuItem>);
                                        });

                                        res.push(<MenuItem value=""></MenuItem>);


                                        nuevoitem.accessor = row => {

                                            //Buscamos obtener el item asociado al valor del campo del item actual
                                            let selected = itemdatasource.items.find(y => y.valor == row[itemdatasource.fieldname]);

                                            //Si de la lista de item a un valor con dicho campo entonces el valor a mostrar sera el nombre asociado
                                            return <span>{selected != null ? selected.name : row[itemdatasource.fieldname]}</span>
                                        }
                                    }

                                    if (res != "") {
                                        nuevoitem.Filter = ({ filter, onChange }) =>
                                            <Select
                                                variant="standard"
                                                onChange={event => onChange(event.target.value)}
                                                style={{ width: "100%" }}
                                                value={filter ? filter.value : ""}
                                            >
                                                {res}
                                            </Select>
                                    }
                                }
                                else if (itemdatasource.tipofield == TipoOthelloFieldGrid.OthelloDateTime) {
                                    nuevoitem.id = itemdatasource.fieldname;
                                    nuevoitem.sortable = true;
                                    nuevoitem.Cell = ({ row }) => {
                                        return row.values[itemdatasource.fieldname] != null ? moment(row.values[itemdatasource.fieldname]).format("DD/MM/YYYY HH:mm:ss") : ""
                                    }
                                    //nuevoitem.sortType = "datetime"
                                    //nuevoitem.accessor = row => <span>{row[itemdatasource.fieldname] != null ? moment(row[itemdatasource.fieldname]).format("DD/MM/YYYY HH:mm:ss") : ""}</span>
                                }
                                else if (itemdatasource.tipofield == TipoOthelloFieldGrid.OthelloDate) {
                                    nuevoitem.id = itemdatasource.fieldname;
                                    nuevoitem.sortable = true;
                                    nuevoitem.Cell = ({ row }) => {
                                        return row.values[itemdatasource.fieldname] != null ? moment(row.values[itemdatasource.fieldname]).format("DD/MM/YYYY") : ""
                                    }
                                    /* nuevoitem.sortMethod = (a, b) => {
                                         let dateA = new Date(moment(a.props.children, 'DD/MM/YYYY'))
                                         let dateB = new Date(moment(b.props.children, 'DD/MM/YYYY'))
                                         return dateB > dateA ? 1 : -1;
                                     }*/
                                    //nuevoitem.sortType = "datetime"
                                    //nuevoitem.accessor = row => <span>{row[itemdatasource.fieldname] != null ? moment(row[itemdatasource.fieldname]).format("DD/MM/YYYY") : ""}</span>
                                }
                                else if (itemdatasource.tipofield == TipoOthelloFieldGrid.OthelloCheckBox) {
                                    //nuevoitem.id = itemdatasource.fieldname; 
                                    nuevoitem.width = itemdatasource.tipofield == TipoOthelloFieldGrid.OthelloCheckBox ? 70 : 40;
                                    nuevoitem.filterable = false;
                                    nuevoitem.sortable = false;


                                    /* nuevoitem.accessor = (row, rowIndex) =>
                                     {
                                         let key = 1 + "_" + itemdatasource.fieldname;
 
                                         return <Checkbox
                                             id={key}
                                             name={key}
                                             tabIndex={-1}
                                             checked={row[itemdatasource.fieldname] == true || row[itemdatasource.fieldname] == false ? row[itemdatasource.fieldname] : false}
                                             disabled={itemdatasource.checkdisabled != null ? itemdatasource.checkdisabled : false}
                                             onChange={(e) => handleCheckOnChange(e, index, itemdatasource.fieldname, itemdatasource.onclick)}
                                             checkedIcon={<Check className={classes.checkedIcon} />}
                                             icon={<Check className={classes.uncheckedIcon} />}
                                             classes={{
                                                 checked: classes.checked,
                                                 root: classes.checkRoot
                                             }}
                                         />
                                     }*/
                                }
                                else if (itemdatasource.tipofield == TipoOthelloFieldGrid.OthelloButton) {
                                    nuevoitem.width = itemdatasource.tipofield == TipoOthelloFieldGrid.OthelloCheckBox ? 70 : 30;
                                    nuevoitem.filterable = false;
                                    nuevoitem.sortable = false;
                                }
                                else if (itemdatasource.tipofield == TipoOthelloFieldGrid.OthelloCurrency) {
                                    nuevoitem.id = itemdatasource.fieldname;
                                    nuevoitem.sortable = true;
                                    nuevoitem.align = "right";
                                    nuevoitem.Cell = ({ row }) => {
                                        try {
                                            return row.values[itemdatasource.fieldname] != null ? row.values[itemdatasource.fieldname].toFixed(2) : "0.00-"
                                        }
                                        catch {
                                            return "0.00-";
                                        }
                                    }
                                    /*nuevoitem.sortMethod = (a, b) => { return parseFloat(a.props.children) - parseFloat(b.props.children); }
                                    nuevoitem.accessor = row => {
                                        try {
                                            return <div style={{ textAlign: "right", marginRight: 10 }}>{row[itemdatasource.fieldname] != null ? row[itemdatasource.fieldname].toFixed(2) : "0.00-"}</div>
                                        }
                                        catch {
                                            return "0.00-";
                                        }
                                    }*/
                                }
                                else if (itemdatasource.tipofield == TipoOthelloFieldGrid.OthelloCurrency4Dec) {
                                    nuevoitem.id = itemdatasource.fieldname;
                                    nuevoitem.sortable = true;
                                    nuevoitem.align = "right";
                                    nuevoitem.Cell = ({ row }) => {
                                        try {
                                            return row.values[itemdatasource.fieldname] != null ? row.values[itemdatasource.fieldname].toFixed(4) : "0.0000-"
                                        }
                                        catch {
                                            return "0.00-";
                                        }
                                    }
                                    //nuevoitem.sortMethod = (a, b) => { return parseFloat(a.props.children) - parseFloat(b.props.children); }
                                    //nuevoitem.accessor = row => {
                                    //    try {
                                    //        return <div style={{ textAlign: "right", marginRight: 10 }}>{row[itemdatasource.fieldname] != null ? row[itemdatasource.fieldname].toFixed(4) : "0.0000-"}</div>
                                    //    }
                                    //    catch {
                                    //        return "0.0000-";
                                    //    }
                                    //}
                                }
                                else if (itemdatasource.tipofield == TipoOthelloFieldGrid.OthelloEditLargo) {
                                    //nuevoitem.id = itemdatasource.fieldname; 
                                    nuevoitem.width = itemdatasource.width != null && itemdatasource.width > 0 ? itemdatasource.width : 150;
                                }
                            } 
                        }

                        columnas.push(nuevoitem);
                    }
                    //sino, es que estamos con el de los botones
                    else {
                        let nuevoitem = { Header: "", accessor: item, sortable: false, filterable: false, width: 30 };
                        columnas.push(nuevoitem);
                    }
                });
            }

            return columnas;
        }
    }

    const getBotonNuevo = (textNuevo, onNuevo) =>
    {
        //Generamos el texto que pondra 
        let textonew = textNuevo != null && textNuevo != "" ? textNuevo : "Nuevo";

        //Generamos un boton de nuevo si me indica que el gri lo tienes
        let botonadd = onNuevo != null ? <Button style={{ height: 38 }} color="millenium" onClick={() => onNuevo()} size="small"><Add />&nbsp;{textonew}</Button> : "";

        return botonadd;
    }

    const getBotonRefresh = (onRefresh) => {

        //Generamos un boton de refresco si me indica que el grif lo tiene
        let botonarefresh = onRefresh != null ? <Button color="instagram" onClick={() => onRefresh()} iconOnly><Refresh /></Button> : "";

        return botonarefresh;
    }

    const getBotonesExtras =  (arrayBotonesExtras, onBotonExtraClick) =>
    {
        let BotonesExtras = "";

        //Si existe botones extras
        if (arrayBotonesExtras != null && arrayBotonesExtras.length > 0)
            BotonesExtras = arrayBotonesExtras.map((prop, key) => { return (<Button style={{ height:38 }} color={prop.color != null && prop.color != "" ? prop.color : "linkedin"} size="small" key={prop.id} onClick={() => onBotonExtraClick(prop.id, prop.permiso)}> <prop.icon />&nbsp;{prop.texto}</Button >); });

        return BotonesExtras;
    }

    const filterCaseInsensitive = (filter, row) => {
        const id = filter.pivotId || filter.id;
        const content = row[id];

        if (typeof content !== 'undefined') {
            // filter by text in the table or if it's a object, filter by key
            if (typeof content === 'object' && content !== null && content.key) {
                return String(content.key).toLowerCase().includes(filter.value.toLowerCase());
            } else {

                let valor = content;
                try {
                    valor = content.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                }
                catch { }

                let filterfinal = filter.value;

                try {
                    filterfinal = filter.value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                }
                catch { }

                return String(valor).toLowerCase().includes(filterfinal.toLowerCase());
            }
        }

        return true;
    };

    const getTable = (gridmode, valores, columnas, permitefiltrar, verpaginaciontop, verpaginacionbottom, tamanopagina, literal) =>
    {
        if (gridmode != null && (gridmode == "simple" || gridmode == "simplecolor"))
            //return <Table tableHead={[]} tableData={[]} />;
            return <Table tableHead={columnas != null && Array.isArray(columnas) ? columnas : []} tableData={valores} />;
        else {
           
            let valor = localStorage.getItem("sizepage");

            if (valor != null && valor != "") {
                tamanopagina = parseInt(valor);
            }

            let pagesize = tamanopagina != null ? tamanopagina : 10;           
       
            return <DataTable table={{ columns: columnas != null && Array.isArray(columnas) ? columnas : [], rows: valores }} entriesPerPage={{ defaultValue: pagesize, entries: [5, 10, 15, 20, 25, 50, 100] }} canSearch={permitefiltrar} showTotalEntries={true} isSorted={true} noEndBorder={false}
                showTotalYPaginacion={showTotalYPaginacion != null ? showTotalYPaginacion : true} />

            //return (<ReactTable
             
            //    filterable={permitefiltrar}
             
             
            //    showPaginationTop={verpaginaciontop}
            //    showPaginationBottom={verpaginacionbottom}
                
            //    defaultFilterMethod={filterCaseInsensitive}
            //    onPageChange={OnPageChange}
            //    onPageSizeChange={OnPageSizeChange}
            //    onSortedChange={OnSortedChange}
            //    onFilteredChange={OnFilteredChange}
                                                                           
                
            ///>);

            //return (<ReactTable
            //    data={valores}
            //    filterable={permitefiltrar}
            //    columns={columnas != null && Array.isArray(columnas) ? columnas : []}
            //    defaultPageSize={pagesize}
            //    showPaginationTop={verpaginaciontop}
            //    showPaginationBottom={verpaginacionbottom}
            //    className="-striped -highlight"
            //    defaultFilterMethod={filterCaseInsensitive}
            //    onPageChange={OnPageChange}
            //    onPageSizeChange={OnPageSizeChange}
            //    onSortedChange={OnSortedChange}
            //    onFilteredChange={OnFilteredChange}
            //    previousText={literal('_previous')}
            //    nextText={literal('_next')}
            //    loadingText={literal('_cargando')}
            //    noDataText={literal('_norows')}
            //    pageText={literal('_pagina')}
            //    ofText={literal('_of')}
            //    rowsText={literal('_rows')}
            ///>);
        }
    }

    const OnPageChange = (indexPage) =>
    {
        if (indexPage != null) {

            let opciones = { ...optionstable };            
            opciones.indexPage = indexPage;
            setoptionstable(opciones);

            if (props.onChangeOptionsFiltroGrid != null)
                props.onChangeOptionsFiltroGrid(opciones);
        }

    }

    const OnPageSizeChange = (itemsView, indexpage) =>{
        if (itemsView != null) {

            let opciones = { ...optionstable };
            opciones.indexPage = indexpage;
            opciones.rowsPage = itemsView;
            setoptionstable(opciones);

            if (props.onChangeOptionsFiltroGrid != null)
                props.onChangeOptionsFiltroGrid(opciones);
        }

    }

    const OnSortedChange = (filtro, column, additive) =>{
        if (filtro != null) {

            let opciones = { ...optionstable };

            if (filtro.length > 0) {
    
                opciones.columnaOrder = filtro[0].id;
                opciones.orderDesc = filtro[0].desc;
                setoptionstable(opciones);
            }

            if (props.onChangeOptionsFiltroGrid != null)
                props.onChangeOptionsFiltroGrid(opciones);
        }
    }

    const OnFilteredChange = (newFiltering, column, value) => {
        if (newFiltering != null) {

            let opciones = { ...optionstable };
            opciones.valuesfiltro = newFiltering;            
            setoptionstable(opciones);
            
            if (props.onChangeOptionsFiltroGrid != null)
                props.onChangeOptionsFiltroGrid(opciones);
        }
    }

    //Si tenemos valores de editar o eliminar, añadimos a la opcion de datos a mostrar la vacia (que sera la de los botones del grid)
    if ((onEdit != null || onDelete != null) && datashow != null && !datashow.some(x => x == "botones"))
        datashow.push("botones");

    //Obtenemos los valores que se van a ver el grid
    let valores = getDataTable(datasource, datashow, datasourcefields, gridmode, onEdit, onDelete);

    //Obtenemos las columnas que se van a mostrar en el grid
    let columnas = getColumnas(datashow, datacabeceros, gridmode, datasourcefields);

    //Obtenemos el boton de nuevo siempre que cumpla con lo necesario
    let botonadd = getBotonNuevo(textNuevo, onNuevo);

    let botonrefresh = getBotonRefresh(onRefresh);

    let botonesExtras = getBotonesExtras(arrayBotonesExtras, onBotonExtraClick)

    let TableFinal = getTable(gridmode, valores, columnas, permitefiltrar, verpaginaciontop, verpaginacionbottom, tamanopagina, t);

    let modal = "";

    //Si el estado del modal es distinto de cerrado
    if (stateModal != DataStateModal.dsClosed)
        modal = <OthelloMensaje tituloliteral="_atmovilidad" descrip={MensajeModalSegunEstado2(modeModal, t, questionDelete)} modo={modeModal} open={stateModal} onCloseResulModal={othelloModalResul} botones={MessageOthelloBoxButtons.OKCancel} />
    
    let checkSelectAll = "";
    if (onSelectAllCheckbox != null)
        checkSelectAll = <p><OthelloCheckBox labelliteral="_selecttodos" checked={false} onChange={onSelectAllCheckbox} /></p>


    return (<div>
        {modal}
        <p><Grid container>{botonrefresh}{botonadd}{botonesExtras}{datosAdicionales}</Grid></p>
        {checkSelectAll}
        {TableFinal}

    </div>);
}


OthelloGrid.propTypes = {
    
    gridmode: PropTypes.oneOf([
        "",
        "simple",
        "simplecolor",
    ]),
    datasource: PropTypes.object.isRequired,
    datacabeceros: PropTypes.object.isRequired,
    datashow: PropTypes.object.isRequired,
    datasourcefields: PropTypes.object, //Se trata de los datasource asociados a los campos concretos
    // ejemplo datasourceCombo.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "campo", items: listaitems, color: 'danger' , onclick: evento, checkdisabled: false})
    //onclick cuando es de check (item, campo);
    //onclick cuando es de check (valor-true/false, row-index, campo);
    onEdit: PropTypes.object,
    onDelete: PropTypes.object,
    onNuevo: PropTypes.object,
    onRefresh: PropTypes.object, //Para que salga el boton que nos permite refrescar el grid   
    textNuevo: PropTypes.string,
    permitefiltrar: PropTypes.bool,
    verpaginaciontop: PropTypes.bool,
    verpaginacionbottom: PropTypes.bool,
    tamanopagina: PropTypes.number,
    onChangeOptionsFiltroGrid: PropTypes.object,
    onSetPropertiesButtonRow: PropTypes.object,
    onBotonExtraClick: PropTypes.object,
    arrayBotonesExtras: [], //Ejemplo: {id:x, icon:x, texto: x, permiso: x, color: 'danger'}
    datosAdicionales: PropTypes.object, //SE trata de informacion que puedes añadir, para que se coloque donde te interese, esto pues ser un panel con combos, etc
    showTotalYPaginacion: PropTypes.bool
};

/*
class OthelloGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {    
            stateModal: DataStateModal.dsClosed,
            modeModal: ModoModal.SinDefinir, 
            itemdelete: null,
            indexdelete: null,
            optionstable: { indexPage: 0, rowsPage: this.props.tamanopagina != null ? this.props.tamanopagina : 10, orderDesc: false, columnaOrder: "", valuesfiltro: [] }
        };
       
        this.handleDelete = this.handleDelete.bind(this);
        this.othelloModalResul = this.othelloModalResul.bind(this);

        this.OnPageChange = this.OnPageChange.bind(this);
        this.OnPageSizeChange = this.OnPageSizeChange.bind(this);        
        this.OnSortedChange = this.OnSortedChange.bind(this);
        this.OnFilteredChange = this.OnFilteredChange.bind(this);        

        this.handleCheckOnChange = this.handleCheckOnChange.bind(this);
    }  


    handleDelete(valor, index)
    {
        if (valor != null) {            
            this.setState({ stateModal: DataStateModal.dsOpen, modeModal: ModoModal.Delete, itemdelete: valor,indexdelete: index});
        }
    }

    othelloModalResul(modo, result, valor) {

        //Si hemos recibido un true es que debemos realizar alguna operacion con los recibido
        if (result == DialogOthelloResult.OK)
        {
            //if (modo == ModoModal.Delete)        
            //Ahora solo esta la opcion de delete, por tanto
            this.props.onDelete(itemdelete, indexdelete);

            this.setState({ stateModal: DataStateModal.dsClosed, modeModal: ModoModal.SinDefinir, itemdelete: null, indexdelete: null });
        }
        //sino simplemente cerramos el modal
        else
            this.setState({ stateModal: DataStateModal.dsClosed, modeModal: ModoModal.SinDefinir, itemdelete: null, indexdelete: null});
    }

    handleCheckOnChange(event, row, campo, eventclick) {        

        //Si cambio el estado anterior
        if (event.target != checkedstate)
        {
            //// this.setState({ [event.target.name]: event.target.value });
            //this.setState({ checkedstate: event.target.checked, evento: true });

            if (eventclick != null)
                eventclick(event.target.checked, row, campo);

           // event.checked = event.target.checked;
        }
    };

    //Metodo que devuelve los datos segun el modo que hemos indicado del grid
    getDataTable(Owner, classes, datasource, datashow, datasourcefields, gridmode, onEdit, onDelete)
    {
        //Si estamos en modo simple
        if (gridmode != null && (gridmode == "simple" || gridmode == "simplecolor"))
        {
            let valores = datasource != null ? datasource.map((item, index) =>
            {
                //Creamos una copia de los valores a mostrar
                let valor_Aux = Object.create(datashow);

                //por cada campo vamos obteniendo el valor y cambiandolo por el valor real
                datashow.map((field, col) =>
                {
                    //Si el campo tiene valor, es que es un campo real
                    if (field != "botones")
                    {
                        //Ahora compruebo que no tiene una conversion
                        if (datasourcefields != null)
                        {
                            //Buscamos el primer datasource que esta asociado al campo con el que estamos trabajando
                            let datafield = datasourcefields.find(x => x.fieldname == field);

                            //Si existe datasource para el campo actual
                            if (datafield != null)
                            {
                                if (datafield.tipofield == TipoOthelloFieldGrid.OthelloComboBox && datafield.items != null) {
                                    //Buscamos obtener el item asociado al valor del campo del item actual
                                    let selected = datafield.items.find(x => x.valor == item[field]);

                                    //Si de la lista de item a un valor con dicho campo entonces el valor a mostrar sera el nombre asociado
                                    if (selected != null)
                                        return valor_Aux[col] = selected.name;
                                }
                                else if (datafield.tipofield == TipoOthelloFieldGrid.OthelloDate || datafield.tipofield == TipoOthelloFieldGrid.OthelloDateTime) {

                                    if (item[field] != null && item[field] != "")
                                    {
                                        let res = item[field]; 
                                        let timefinal = new Date(res);

                                        if (timefinal != "Invalid Date")
                                            res = moment(timefinal).format("DD/MM/YYYY");

                                        return valor_Aux[col] = res;
                                    }
                                    else
                                        return valor_Aux[col] = "";
                                }
                                else if (datafield.tipofield == TipoOthelloFieldGrid.OthelloImagen)
                                    return valor_Aux[col] = <img style={{ height: "42px", width: "42px" }} src={item[field]} alt="..." className={classes.img} />      
                                else if (datafield.tipofield == TipoOthelloFieldGrid.OthelloCurrency) 
                                    return valor_Aux[col] = <div style={{ textAlign: "right", marginRight: 10 }}>{item[field] != null ? item[field].toFixed(2) : "0.00-"}</div>                          
                                else if (datafield.tipofield == TipoOthelloFieldGrid.OthelloCurrency4Dec) 
                                    return valor_Aux[col] = <div style={{ textAlign: "right", marginRight: 10 }}>{item[field] != null ? item[field].toFixed(4) : "0.0000-"}</div>
                                //else if (datafield.tipofield == TipoOthelloFieldGrid.OthelloCheckBox)
                                 //   return valor_Aux[col] = <div style={{ textAlign: "right", marginRight: 10 }}>{item[field] != null ? item[field].toFixed(4) : "0.0000-"}</div>      
                            }
                        }

                        //Si llego hasta qui es que no tiene datasource asociado o valor dentro de este por tanto, le asociado el valor que tenia
                        return valor_Aux[col] = item[field];
                    }
                    //sino, es el campo que ponemos por defecto para los botones
                    else
                        return valor_Aux[col] = GetGridButtons(classes, item, index, onEdit, onDelete != null ? this.handleDelete : null);
                });

                //Si estamos en modo simple directamento proporciono el valor
                if (gridmode == "simple")
                    return valor_Aux;
                //Sino, trato con el color
                else
                {
                    let colorfinal = index % 2 == 0 ? "info" : "";

                    let recipient =
                    {
                        color: colorfinal,
                        data: valor_Aux,
                    };

                    return recipient;
                }
            }) : [];

            return valores;
        }      
        //Sino, es que estamos en modo normal, que es el de ReactTable
        else
        {
            let valores = datasource != null && datasource.length>0 ? datasource.map((item, index) =>
            {              
                let recipient = "";

                //Si tenemos botones de edicion o eliminacion entonces debo añadir al item un campo de botones
                if (onEdit != null || onDelete != null) {
                    recipient =
                    {
                        ...item,
                        botones: GetGridButtons(classes, item, index, onEdit, onDelete != null ? this.handleDelete : null)
                    };
                }
                else {
                    recipient = item;
                }

                //Ahora compruebo que no tiene una conversion
                if (datasourcefields != null)
                {
                    //Buscamos el primer datasource que esta asociado al campo con el que estamos trabajando
                    datasourcefields.map(x =>
                    {
                        if (x.tipofield == TipoOthelloFieldGrid.OthelloImagen)
                            recipient[x.fieldname] = <img style={{ height:"42px", width:"42px" }}  src={recipient[x.fieldname]} alt="..." className={classes.img} />
                        else if (x.tipofield == TipoOthelloFieldGrid.OthelloButton)
                        {
                            let colorfinal = { color: x.color, disabled: false };

                            if (props.onSetPropertiesButtonRow != null)
                                props.onSetPropertiesButtonRow(item, x.fieldname, colorfinal);

                            return recipient[x.fieldname] = <Button className={classes.actionButton} onClick={() => x.onclick != null ? x.onclick(item, x.fieldname) : {}} color={colorfinal != null && colorfinal.color != null ? colorfinal.color : ''} disabled={colorfinal.disabled}>
                                <x.icon className={classes.icon} />
                            </Button>
                        }                    
                        else if (x.tipofield == TipoOthelloFieldGrid.OthelloCheckBox)
                        {
                            try {
                                let key = index + "_" + x.fieldname;

                                
                                //Si no estamos con un componente valido es que estamos con el valor del checkBox, si no, es que estamos con el propio checkBox
                                if (!React.isValidElement(recipient[x.fieldname]))
                                {
                                    recipient[x.fieldname] = <Checkbox
                                        id={key}
                                        name={key}
                                        tabIndex={-1}
                                        checked={recipient[x.fieldname] == true || recipient[x.fieldname] == false ? recipient[x.fieldname] : false}
                                        disabled={x.checkdisabled != null ? x.checkdisabled : false}
                                        onChange={(e) => handleCheckOnChange(e, index, x.fieldname, x.onclick)}
                                        checkedIcon={<Check className={classes.checkedIcon} />}
                                        icon={<Check className={classes.uncheckedIcon} />}
                                        classes={{
                                            checked: classes.checked,
                                            root: classes.checkRoot
                                        }}
                                    />
                                }
                            }
                            catch { }                                                     
                        }
                    });                        
                }

                return recipient;                

            }) : [];

            return valores;
        }
    }

    getColumnas(Owner, classes, datashow, datacabeceros, gridmode, datasourcefields)
    {
        //Si estamos en modo simple las columnas son directamente las que me indique los cabeceros
        if (gridmode != null && (gridmode == "simple" || gridmode == "simplecolor"))
            return datacabeceros != null && datacabeceros != "" && Array.isArray(datacabeceros) ? datacabeceros : [];
        //sino, en modo normal monto las columnas con las propiedades necesarias
        else
        {
            let columnas = [];

            if (datashow != null && Array.isArray(datashow))
            {
                datashow.map((item, index) => {

                    //Si el campo no indica botones entonces
                    if (item != "botones")
                    {                       
                        let cabecera = datacabeceros[index];

                        let nuevoitem = { Header: cabecera, accessor: item };

                        //Ahora compruebo que no tiene una conversion
                        if (datasourcefields != null)
                        {
                            //Busco si hay algun combo asociado al item a tratar
                            let itemdatasource = datasourcefields.find(x => (x.tipofield == TipoOthelloFieldGrid.OthelloComboBox || x.tipofield == TipoOthelloFieldGrid.OthelloButton || x.tipofield == TipoOthelloFieldGrid.OthelloCheckBox
                                || x.tipofield == TipoOthelloFieldGrid.OthelloDateTime || x.tipofield == TipoOthelloFieldGrid.OthelloDate || x.tipofield == TipoOthelloFieldGrid.OthelloCurrency
                                || x.tipofield == TipoOthelloFieldGrid.OthelloCurrency4Dec) && x.fieldname == item);

                            //Si se ha encontrado un item
                            if (itemdatasource != null) {
                                //Si el item es de tipo ComboBox
                                if (itemdatasource.tipofield == TipoOthelloFieldGrid.OthelloComboBox) {
                                    let res = "";

                                    nuevoitem.id = itemdatasource.fieldname;
                                    nuevoitem.sortable = true;
                                    nuevoitem.sortMethod = (a, b) => {

                                        let aaa = a.props.children +"";
                                        let bbb = b.props.children+"";

                                        if (aaa > bbb)
                                            return 1;
                                        if (bbb > aaa)
                                            return -1;

                                        return 0;
                                    }

                                    //Si hay items
                                    if (itemdatasource != null && itemdatasource.tipofield == TipoOthelloFieldGrid.OthelloComboBox && itemdatasource.items != null && itemdatasource.items.length > 0)
                                    {
                                        res = itemdatasource.items.map((prop, key) => {
                                            return (<MenuItem value={prop.name}>{prop.name}</MenuItem>);
                                        });

                                        res.push(<MenuItem value=""></MenuItem>);


                                        nuevoitem.accessor = row => {

                                            //Buscamos obtener el item asociado al valor del campo del item actual
                                            let selected = itemdatasource.items.find(y => y.valor == row[itemdatasource.fieldname]);

                                            //Si de la lista de item a un valor con dicho campo entonces el valor a mostrar sera el nombre asociado
                                            return <span>{selected != null ? selected.name : row[itemdatasource.fieldname]}</span>                                                
                                       }                                         
                                    }

                                    if (res != "")
                                    {
                                        nuevoitem.Filter = ({ filter, onChange }) =>
                                            <Select
                                                onChange={event => onChange(event.target.value)}
                                                style={{ width: "100%" }}
                                                value={filter ? filter.value : ""}
                                            >
                                                {res}
                                            </Select>                                       
                                    }
                                }
                                else if (itemdatasource.tipofield == TipoOthelloFieldGrid.OthelloDateTime) {
                                    nuevoitem.id = itemdatasource.fieldname;
                                    nuevoitem.sortable = true;
                                    nuevoitem.sortType = "datetime"
                                    nuevoitem.accessor = row => <span>{row[itemdatasource.fieldname] != null ? moment(row[itemdatasource.fieldname]).format("DD/MM/YYYY HH:mm:ss") : ""}</span>
                                }
                                else if (itemdatasource.tipofield == TipoOthelloFieldGrid.OthelloDate) {
                                    nuevoitem.id = itemdatasource.fieldname;
                                    nuevoitem.sortable = true;
                                    nuevoitem.sortMethod = (a, b) => {
                                        let dateA = new Date(moment(a.props.children, 'DD/MM/YYYY'))
                                        let dateB = new Date(moment(b.props.children, 'DD/MM/YYYY'))
                                        return dateB > dateA ? 1 : -1;
                                    }
                                    nuevoitem.sortType = "datetime"
                                    nuevoitem.accessor = row => <span>{row[itemdatasource.fieldname] != null ? moment(row[itemdatasource.fieldname]).format("DD/MM/YYYY") : ""}</span>
                                }    
                                else if (itemdatasource.tipofield == TipoOthelloFieldGrid.OthelloCheckBox)
                                {
                                    //nuevoitem.id = itemdatasource.fieldname; 
                                    nuevoitem.width = itemdatasource.tipofield == TipoOthelloFieldGrid.OthelloCheckBox ? 70 : 40;
                                    nuevoitem.filterable = false;
                                    nuevoitem.sortable = false;


                                   /* nuevoitem.accessor = (row, rowIndex) =>
                                    {
                                        let key = 1 + "_" + itemdatasource.fieldname;

                                        return <Checkbox
                                            id={key}
                                            name={key}
                                            tabIndex={-1}
                                            checked={row[itemdatasource.fieldname] == true || row[itemdatasource.fieldname] == false ? row[itemdatasource.fieldname] : false}
                                            disabled={itemdatasource.checkdisabled != null ? itemdatasource.checkdisabled : false}
                                            onChange={(e) => handleCheckOnChange(e, index, itemdatasource.fieldname, itemdatasource.onclick)}
                                            checkedIcon={<Check className={classes.checkedIcon} />}
                                            icon={<Check className={classes.uncheckedIcon} />}
                                            classes={{
                                                checked: classes.checked,
                                                root: classes.checkRoot
                                            }}
                                        />
                                    }                                     
                                }
                                else if (itemdatasource.tipofield == TipoOthelloFieldGrid.OthelloButton) {
                                    nuevoitem.width = itemdatasource.tipofield == TipoOthelloFieldGrid.OthelloCheckBox ? 70 : 40;
                                    nuevoitem.filterable = false;
                                    nuevoitem.sortable = false;
                                }
                                else if (itemdatasource.tipofield == TipoOthelloFieldGrid.OthelloCurrency)
                                {
                                    nuevoitem.id = itemdatasource.fieldname;                                 
                                    nuevoitem.sortable = true;
                                    nuevoitem.sortMethod = (a, b) => { return parseFloat(a.props.children) - parseFloat(b.props.children); }
                                    nuevoitem.accessor = row => 
                                    {
                                        try {
                                            return <div style={{ textAlign: "right", marginRight: 10 }}>{row[itemdatasource.fieldname] != null ? row[itemdatasource.fieldname].toFixed(2) : "0.00-"}</div>
                                        }
                                        catch {
                                            return "0.00-";
                                        }                                        
                                    }                                    
                                }     
                                else if (itemdatasource.tipofield == TipoOthelloFieldGrid.OthelloCurrency4Dec) {
                                    nuevoitem.id = itemdatasource.fieldname;
                                    nuevoitem.sortable = true;
                                    nuevoitem.sortMethod = (a, b) => { return parseFloat(a.props.children) - parseFloat(b.props.children); }
                                    nuevoitem.accessor = row => {
                                        try {
                                            return <div style={{ textAlign: "right", marginRight: 10 }}>{row[itemdatasource.fieldname] != null ? row[itemdatasource.fieldname].toFixed(4) : "0.0000-"}</div>
                                        }
                                        catch {
                                            return "0.0000-";
                                        }
                                    }
                                }                          
                            }
                        }

                        columnas.push(nuevoitem);
                    }
                    //sino, es que estamos con el de los botones
                    else {
                        let nuevoitem = { Header: "", accessor: item, sortable: false, filterable: false, width:80 };
                        columnas.push(nuevoitem);
                    }
                });
            }

            return columnas;
        }
    }

    getBotonNuevo(textNuevo, onNuevo)
    {
        //Generamos el texto que pondra 
        let textonew = textNuevo != null && textNuevo != "" ? textNuevo : "Nuevo";

        //Generamos un boton de nuevo si me indica que el gri lo tienes
        let botonadd = onNuevo != null ? <Button color="primary" onClick={() => onNuevo()} size="sm"><Add />{textonew}</Button> : "";

        return botonadd;
    }

    getBotonRefresh(onRefresh) {
       
        //Generamos un boton de refresco si me indica que el grif lo tiene
        let botonarefresh = onRefresh != null ? <Button color="info" onClick={() => onRefresh()} size="sm"><Refresh /></Button> : "";

        return botonarefresh;
    }

    getBotonesExtras(arrayBotonesExtras, onBotonExtraClick)
    {
        let BotonesExtras = "";

        //Si existe botones extras
        if (arrayBotonesExtras != null && arrayBotonesExtras.length > 0)
            BotonesExtras = arrayBotonesExtras.map((prop, key) => { return (<Button color={prop.color != null && prop.color != "" ? prop.color : "linkedin" } size = "sm" key = { prop.id } onClick = {() => onBotonExtraClick(prop.id, prop.permiso)}> <prop.icon />{ prop.texto }</Button >); });

        return BotonesExtras;
    }

    filterCaseInsensitive = (filter, row) => {
        const id = filter.pivotId || filter.id;
        const content = row[id];

        if (typeof content !== 'undefined') {
            // filter by text in the table or if it's a object, filter by key
            if (typeof content === 'object' && content !== null && content.key) {
                return String(content.key).toLowerCase().includes(filter.value.toLowerCase());
            } else {

                let valor = content;
                try {
                    valor = content.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                }
                catch{ }

                let filterfinal = filter.value;

                try {
                    filterfinal = filter.value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                }
                catch{ }

                return String(valor).toLowerCase().includes(filterfinal.toLowerCase());
            }
        }

        return true;
    };

    getTable(gridmode, valores, columnas, permitefiltrar, verpaginaciontop, verpaginacionbottom, tamanopagina, literal)
    {
        if (gridmode != null && (gridmode == "simple" || gridmode == "simplecolor"))
            return <Table tableHead={columnas != null && Array.isArray(columnas) ? columnas : [] } tableData={valores} />;
        else
        {
            let pagesize = tamanopagina != null ? tamanopagina : 10;
          
            return (<ReactTable
                data={valores}
                filterable={permitefiltrar}
                columns={columnas != null && Array.isArray(columnas) ? columnas : []}
                defaultPageSize={pagesize}
                showPaginationTop={verpaginaciontop}
                showPaginationBottom={verpaginacionbottom}
                className="-striped -highlight"
                defaultFilterMethod={this.filterCaseInsensitive}
                onPageChange={this.OnPageChange}
                onPageSizeChange={this.OnPageSizeChange}
                onSortedChange={this.OnSortedChange}
                onFilteredChange={this.OnFilteredChange}
                previousText={literal('_previous')}
                nextText={literal('_next')}
                loadingText={literal('_cargando')}
                noDataText={literal('_norows')}
                pageText={literal('_pagina')}
                ofText={literal('_of')}
                rowsText={literal('_rows')}
            />);
        }
    }

    OnPageChange(indexPage)
    {
        if (indexPage != null)
        {
            optionstable.indexPage = indexPage;

            if (this.props.onChangeOptionsFiltroGrid != null)
                this.props.onChangeOptionsFiltroGrid(optionstable);
        }
        
    }

    OnPageSizeChange(itemsView, indexpage) {
        if (itemsView != null)
        {
            optionstable.indexPage = indexpage;
            optionstable.rowsPage = itemsView;

            if (this.props.onChangeOptionsFiltroGrid != null)
                this.props.onChangeOptionsFiltroGrid(optionstable);
        }
            
    }

    OnSortedChange(filtro, column, additive) {
        if (filtro != null)
        {
            if (filtro.length > 0) {
                optionstable.columnaOrder = filtro[0].id
                optionstable.orderDesc = filtro[0].desc
            }

            if (this.props.onChangeOptionsFiltroGrid != null)
                this.props.onChangeOptionsFiltroGrid(optionstable);
        }            
    }

    OnFilteredChange(newFiltering, column, value) {
        if (newFiltering != null) {
            valuesfiltro = newFiltering;

            if (this.props.onChangeOptionsFiltroGrid != null)
                this.props.onChangeOptionsFiltroGrid(optionstable);
        }
    }
     
    render()
    { 
        const { classes, gridmode, datasource, datacabeceros, datashow, datasourcefields, onEdit, onDelete, onNuevo, onRefresh, textNuevo, permitefiltrar, verpaginaciontop, verpaginacionbottom, tamanopagina, t, arrayBotonesExtras, onBotonExtraClick} = this.props

        //Si tenemos valores de editar o eliminar, añadimos a la opcion de datos a mostrar la vacia (que sera la de los botones del grid)
        if ((onEdit != null || onDelete != null) && datashow != null && !datashow.some(x => x == "botones")) 
            datashow.push("botones");        
        
        //Obtenemos los valores que se van a ver el grid
        let valores = this.getDataTable(this, classes, datasource, datashow, datasourcefields, gridmode, onEdit, onDelete);

        //Obtenemos las columnas que se van a mostrar en el grid
        let columnas = this.getColumnas(this, classes, datashow, datacabeceros, gridmode, datasourcefields);
       
        //Obtenemos el boton de nuevo siempre que cumpla con lo necesario
        let botonadd = this.getBotonNuevo(textNuevo, onNuevo);

        let botonrefresh = this.getBotonRefresh(onRefresh);

        let botonesExtras = this.getBotonesExtras(arrayBotonesExtras, onBotonExtraClick) 

        let Table = this.getTable(gridmode, valores, columnas, permitefiltrar, verpaginaciontop, verpaginacionbottom, tamanopagina, t);

        let modal = "";

        //Si el estado del modal es distinto de cerrado
        if (stateModal != DataStateModal.dsClosed)            
            modal = <OthelloMensaje tituloliteral="_othelloweb" descrip={MensajeModalSegunEstado(modeModal, t)} modo={modeModal} open={stateModal} onCloseResulModal={this.othelloModalResul} />

        return (<div>
            {modal}
            <p>{botonrefresh}{botonadd}{botonesExtras}</p>
            {Table}
            
        </div>);

    }
}

export default withTranslation()(withStyles(extendedTablesStyle)(OthelloGrid));*/
